"use client";

import { useMemo, type ReactNode } from "react";
import {
  LoopClockContext,
  useLoopState,
  type LoopApi,
} from "./use-loop-clock";

/**
 * Mounts the practice loop's clock. See
 * `use-loop-clock.ts` for why the clock behaves the way it does; this
 * file exists so the module that holds React context exports only
 * components, which is what makes fast refresh work.
 */
export function LoopClockProvider({ children }: { children: ReactNode }) {
  const state = useLoopState();

  const api = useMemo<LoopApi>(() => ({ ...state }), [state]);

  return (
    <LoopClockContext.Provider value={api}>
      {children}
    </LoopClockContext.Provider>
  );
}

export default LoopClockProvider;
